// extracted by mini-css-extract-plugin
export default {"carousel-swiper":"ZyONK3KjQfsi9uQSU7Y1","carouselSwiper":"ZyONK3KjQfsi9uQSU7Y1"};